module.exports = "<span><span v-text=\"remaining\"></span></span>\n";